import { useState, useEffect, useCallback, useRef } from 'react';
import Axios from 'axios';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import franquicias from 'src/assets/img/franquicias.png';
import { useParams, useLocation } from 'react-router-dom';
import { withToastManager } from 'react-toast-notifications';
import useCustomToast from 'src/hooks/useCustomToast';
import { FooterLanding, IconCheckCircle } from 'src/assets/svg';
import ContactoAsesor from 'src/pages/Landing/ContactoAsesor';
import useThemeService from 'src/services/useThemeService';
import { Box, Button, Span, Nav, Label, TabButton, P, Li, Carousel, I, H4 } from 'src/component';
import InicioCotizacion from 'src/pages/Landing/InicioCotizacion';
import { urlGetProductos, urlGetInfoGrupos, urlFormaPagoDudas } from 'src/services/urls';
import useLoading from 'src/hooks/useLoading';
import { UrlImagenes } from 'src/parametros';
import Asesor from 'src/assets/svg/asesor.svg';
import AcordionComponent from 'src/components/Acordion';
import DatosProductoComponent from './DatosProducto';
import DudasMultiple from './DudasMultiples';
import useB4BreakPoints from 'src/hooks/useB4BreakPoints';
import 'bootstrap/js/src/collapse.js';
import ReactPlayer from 'react-player';
import { height } from 'styled-system';
import LoadingWrapperHTML from 'src/components/Loading/LoadingWrapperHTML';
import useLabelSeguro from 'src/hooks/useLabelSeguro';
import Tracking from 'src/utils/tracking';
import useFavicon from 'src/hooks/useFavicon';
import { Checkbox } from 'primereact/checkbox';

const LandingAceptacionDatos = () => {
  //const { parametros, idUsuario } = useParams<{ parametros: string, idUsuario: string }>()
  const { aseguradora, canal, grupo, canalComercial } = useParams<{ aseguradora: string; canal: string; grupo: string; canalComercial: string }>();
  const { values, setLoading, setSecundario, resetLoading } = useLoading(false);
  const [active, setactive] = useState(false);

  return (
    <LoadingWrapperHTML {...values}>
      <div
        className="d-flex flex-row "
        style={{ height: '100vh', width: '100%', flex: 1, alignItems: 'center', justifyContent: 'center' }}
      >
        <div className='flex' style={{alignItems: "center", height: "225px", width: "362px", background: "#f1f1f1", justifyContent: "center", borderRadius: "40px"}} >
          <Checkbox
            inputId="terminosCondiciones"
            className="check__aceptar__terminos__condiciones mx-2"
            onChange={({ checked }) => setactive(checked)}
            checked={active}
          />
          <label htmlFor="terminosCondiciones" className="label__aceptar__terminos__condiciones form-check-label  ml-2" style={{ maxWidth: '250px', fontSize: "14px" }}>
            Acepto comprar el seguro
          </label>
        </div>
      </div>
    </LoadingWrapperHTML>
  );
};

export default withToastManager(LandingAceptacionDatos);
